import React from 'react';
import { NavLink } from 'react-router-dom';
import { UilUserCheck, UilBriefcase } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';

export const getInvestorsMenuItems = (basePath, toggleCollapsed, topMenu) => {
  const { t } = useTranslation();
  return [
    {
      key: 'investors',
      label: t('Investors'),
      icon: !topMenu && <UilUserCheck size={20} />,
      children: [
        {
          key: 'investors-add',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/investor/registration`}>
              {t('Add Investor')}
            </NavLink>
          ),
        },
        {
          key: 'investors-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/investor/list`}>
              {t('Investors List')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'investment',
      label: t('Investment'),
      icon: !topMenu && <UilBriefcase size={20} />,
      children: [
        {
          key: 'investments-new',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/investment/registration`}>
              {t('New Investment')}
            </NavLink>
          ),
        },
        {
          key: 'investments-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/investment/list`}>
              {t('Investments List')}
            </NavLink>
          ),
        },
      ],
    },
    // {
    //   key: 'wallet',
    //   label: t('Wallet'),
    //   icon: !topMenu && <UilWallet size={20} />,
    //   children: [
    //     {
    //       key: 'wallet-balance',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/wallet/balance`}>
    //           {t('Balance')}
    //         </NavLink>
    //       ),
    //     },
    //     {
    //       key: 'wallet-transactions',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/wallet/transactions`}>
    //           {t('Transactions')}
    //         </NavLink>
    //       ),
    //     },
    //   ],
    // },
    // {
    //   key: 'transactions',
    //   label: t('Transactions'),
    //   icon: !topMenu && <UilTransaction size={20} />,
    //   children: [
    //     {
    //       key: 'transactions-new',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/transactions/new`}>
    //           {t('New Transaction')}
    //         </NavLink>
    //       ),
    //     },
    //     {
    //       key: 'transactions-history',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/transactions/history`}>
    //           {t('Transaction History')}
    //         </NavLink>
    //       ),
    //     },
    //     {
    //       key: 'transactions-reports',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/transactions/reports`}>
    //           {t('Transaction Reports')}
    //         </NavLink>
    //       ),
    //     },
    //   ],
    // },
  ];
};
